import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileSpreadsheetIcon, UploadCloudIcon } from 'lucide-react';
import { DatabaseImportStep, emptyImportState, type ImportKind, type ImportResult, type ImportState } from '../components/onboarding/DatabaseImportStep';
import { importHistory } from '../data/importHistory';
import { useToast } from '../contexts/ToastContext';
export function ImportDataPage() {
  const {
    showToast
  } = useToast();
  const [imports, setImports] = useState<ImportState>(emptyImportState);
  const pendingCount = (imports.leads?.recordCount ?? 0) + (imports.realtors?.recordCount ?? 0);
  const handleImport = () => {
    showToast(`Importing ${pendingCount} records. You will get a summary when mapping completes.`);
    setImports(emptyImportState);
  };
  return <main className="w-full px-4 py-5 sm:px-6 sm:py-6 lg:px-8" data-id="element-610" data-mp="2y7cakewkwsyj">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-5" data-id="element-611" data-mp="2u6il3h3hn63j">
        <header data-id="element-612" data-mp="2u9ejt7n5tyt1">
          <h1 className="text-2xl font-bold tracking-tight text-navy-900" data-id="element-613" data-mp="2welih42kdgoo">
            Import Data
          </h1>
          <p className="mt-1 text-sm text-navy-600" data-id="element-614" data-mp="315bp0kmq7pky">
            Bring in leads, past clients, realtor partners, and prospects any
            time — after a brokerage move, a CRM switch, or when you buy a new
            list. Same importer used in{' '}
            <Link to="/plan" className="font-semibold text-brand-600 hover:underline" data-id="element-615" data-mp="2rd60jkvonqai">
              My Perfect Week
            </Link>{' '}
            setup.
          </p>
        </header>

        <section className="rounded-2xl border border-navy-100 bg-white p-5 shadow-card sm:p-6" data-id="element-616" data-mp="364es3zj5blqa">
          <DatabaseImportStep imports={imports} onChange={(kind: ImportKind, result: ImportResult | null) => setImports(current => ({
          ...current,
          [kind]: result
        }))} data-id="element-617" data-mp="3a5gnu6dutfni" />

          <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-navy-100 pt-4" data-id="element-618" data-mp="1yrcsowvj5lgv">
            <p className="text-xs text-navy-500" data-id="element-619" data-mp="57b7qaim88ql">
              {pendingCount > 0 ? `${pendingCount} records staged and ready to map` : 'Add a CSV file to begin'}
            </p>
            <button type="button" onClick={handleImport} disabled={pendingCount === 0} className="inline-flex h-11 items-center gap-2 rounded-lg bg-brand-600 px-4 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50" data-id="element-620" data-mp="3rlm2lwgypkcw">
              <UploadCloudIcon className="h-4 w-4" aria-hidden="true" data-id="element-621" data-mp="3dpqtujga1pn8" />
              Start import
            </button>
          </div>
        </section>

        <section aria-labelledby="import-history-heading" className="rounded-2xl border border-navy-100 bg-white shadow-card" data-id="element-622" data-mp="33q9lfu9n4xnk">
          <header className="border-b border-navy-100 px-5 py-4" data-id="element-623" data-mp="16uu1xpxsmmb5">
            <h2 id="import-history-heading" className="text-sm font-semibold text-navy-900" data-id="element-624" data-mp="11ymsvoa3ouoz">
              Import history
            </h2>
            <p className="mt-0.5 text-xs text-navy-500" data-id="element-625" data-mp="1efnwwjamytlx">
              Records added to your database from past uploads
            </p>
          </header>
          <ul className="divide-y divide-navy-100" data-id="element-626" data-mp="1o6itohlidblm">
            {importHistory.map(record => <li key={record.id} className="flex flex-wrap items-center gap-3 px-5 py-4" data-id="element-627" data-mp="rg9jg2ayahhi">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy-50 text-navy-600" data-id="element-628" data-mp="viwfygikgql1">
                  <FileSpreadsheetIcon className="h-4 w-4" aria-hidden="true" data-id="element-629" data-mp="10fd4hbtoh6yn" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-630" data-mp="15hlvw3qwk0yn">
                  <p className="truncate text-sm font-semibold text-navy-900" data-id="element-631" data-mp="2bwd28mysoe02">
                    {record.fileName}
                  </p>
                  <p className="text-xs text-navy-500" data-id="element-632" data-mp="2gtwmc3i6bkzx">
                    {record.kindLabel} · {record.dateLabel}
                  </p>
                </div>
                <dl className="shrink-0 text-right text-xs" data-id="element-633" data-mp="3ktbdrn0pujha">
                  <dt className="text-navy-500" data-id="element-634" data-mp="3kv4kf2bbx3pa">Created</dt>
                  <dd className="font-bold tabular-nums text-navy-900" data-id="element-635" data-mp="2ohsf857bie4">
                    {record.created}
                  </dd>
                </dl>
              </li>)}
          </ul>
        </section>
      </div>
    </main>;
}